<script setup>
import { computed } from 'vue';
import AppApiInfoCodeBlock from './ApiInfoCodeBlock.vue';

const props = defineProps({
  variables: {
    type: Object,
    required: false,
  },
  jsonSchema: {
    type: Object,
    default: () => ({}),
  },
});

const payloadString = computed(() => {
  const propVariables = props.variables?.payload;
  if (!propVariables) {
    return propVariables;
  }
  const varString = JSON.stringify(
    propVariables,
    (k, v) => (v === undefined ? '__undefined' : v),
    '\t'
  ).replace(/"__undefined"/g, 'undefined');
  return varString;
});
</script>

<template>
  <div>
    <app-api-info-code-block header="JSON schema:" :code="jsonSchema" />
    <app-api-info-code-block
      v-if="payloadString"
      header="Example payload:"
      subheader="Example payload for the schema based on the form. Note: `undefined` is not a valid value for payload variables but can appear here to show all accepted properties."
      :code="payloadString"
    />
  </div>
</template>
